import Vue from 'vue'
import liff from '@line/liff'
import Util from '@/helper/Utility.js'
import moment from 'moment'
//import Locale from '@/helper/locale/locale.js'
import Locale from '@/helper/Locale.js'
import BzbsAuth from '@/core/Account/service/BzbsAuth.js'
import BzbsProfile from '@/core/Account/service/BzbsProfile.js'
import Config from '@/helper/Config.js'
import {
  ProfileModel,
  ProfileAddressModel,
  ProfileShippingAddressModel,
} from '@/core/Account/model/AccountModel.js'

//Main key.
const KEY_COOKIE_USER = 'BzbsUser_'
const KEY_COOKIE_FACEBOOK_USER = 'BzbsFacebookUser_'
const KEY_COOKIE_PROFILE = 'BzbsProfile'
const KEY_COOKIE_TOKEN = 'BzbsToken_'
const KEY_COOKIE_LOGIN = 'BzbsLogin_'
const KEY_COOKIE_WALLET_TOKEN = 'BzbsWalletToken_'
const KEY_COOKIE_PROFILE_ADDRESS = 'BzbsProfileAddress'
const KEY_COOKIE_PROFILE_SHIPPING_ADDRESS = 'BzbsProfileShippingAddress'
const KEY_COOKIE_REGISTERSTORE = 'RegisterStore_'
const KEY_COOKIE_ECOMURL = 'EcomUrl_'
const KEY_COOKIE_Marketing_Consent = 'Marketing_Consent_'
const KEY_COOKIE_CONSENT = 'vue-cookie-accept-decline-myCookieConsumer'

/**
 * Token
 * @method getToken
 * @method setCacheToken
 * @method getCacheToken
 * @method removeCacheToken
 * @method setCacheWalletToken
 * @method getCacheWalletToken
 * @method removeCacheWalletToken
 *
 * Cache
 * @method getCacheUser
 * @method setCacheUser
 * @method removeCacheUser
 * @method getCacheFacebookUser
 * @method setCacheFacebookUser
 * @method removeCacheFacebookUser
 * @method getCachePoint
 * @method updatePoint
 * @method getCacheCustom
 * @method setCacheCustom
 * @method removeCacheCustom
 * @method getCacheCustomByAppId
 * @method setCacheCustomByAppId
 * @method removeCacheCustomByAppId
 *
 * Login
 * @method setLogin
 * @method setLogout
 * @method loginStatus
 * @method isLogin
 *
 * Api login
 * @method apiGetPoint
 * @method apiBzbsLogin
 * @method apiBzbsFacebookLogin
 * @method apiDeviceLogin
 * @method apiFBLogin
 * @method apiLogout
 *
 * Cache profile
 * @method getCacheProfile
 * @method setCacheProfile
 * @method removeCacheProfile
 * @method getCacheProfileAddress
 * @method setCacheProfileAddress
 * @method removeCacheProfileAddress
 * @method getCacheProfileShippingAddres
 * @method setCacheProfileShippingAddres
 * @method removeCacheProfileShippingAddres
 * @method setCacheAllProfile
 * @method removeCacheAllProfile
 *
 * Api profile
 * @method apiGetProfile
 * @method apiUpdateProfile
 * @method apiUpdateProfileLocale
 * @method apiUpdateProfileShippingAddress
 */
export default {
  config: function () {
    return Vue.bzbsConfig
  },
  initial: function () {
    Vue.initFinished = false
    Config.getConfig().then(() => {
      Locale.callBlobVersion().then(() => {
        Locale.getLbl()
      })
    })
    this.apiGetProfile()
      .then(() => {
        Vue.initFinished = true
      })
      .catch(() => {
        Vue.initFinished = true
      })
  },
  //#region user
  /**
   * Get user token.
   * @return {string|null} user token.
   */
  getToken: function () {
    return this.getCacheToken() ? this.getCacheToken() : null
  },
  getCacheAppId: function () {
    try {
      return JSON.parse(Vue.$cookies.get('app_id'))
    } catch (e) {
      return Vue.$cookies.get('app_id')
    }
  },

  getLocale: function () {
    return this.getCacheUser() ? this.getCacheUser().locale : 1054
  },
  updateLocale: function (strLocale) {
    let objUser = this.getCacheUser() ? this.getCacheUser() : {}
    objUser.locale = strLocale
    this.setCacheUser(objUser)
    return objUser
  },
  /**
   * Get cache user.
   * @return {object} Cache user.
   */
  getCacheUser: function () {
    return Vue.$cookies.get(KEY_COOKIE_USER + this.getCacheAppId())
  },
  getCacheFacebookUser: function () {
    return Vue.$cookies.get(KEY_COOKIE_FACEBOOK_USER + this.getCacheAppId())
  },
  setCacheToken: function (token) {
    if (this.getCacheAppId() != null) {
      this.removeCacheToken()
      Vue.$cookies.set(
        KEY_COOKIE_TOKEN + this.getCacheAppId(),
        token,
        '3m',
        null,
        null,
        true,
        'Strict',
      )
    }
  },
  getCacheToken: function () {
    return Vue.$cookies.get(KEY_COOKIE_TOKEN + this.getCacheAppId())
  },
  removeCacheToken: function () {
    Vue.$cookies.remove(KEY_COOKIE_TOKEN + this.getCacheAppId())
  },

  setCacheWalletToken: function (token) {
    if (this.getCacheAppId() != null) {
      this.removeCacheWalletToken()
      Vue.$cookies.set(
        KEY_COOKIE_WALLET_TOKEN + this.getCacheAppId(),
        token,
        '3m',
        null,
        null,
        true,
        'Strict',
      )
    }
  },
  getCacheWalletToken: function () {
    return Vue.$cookies.get(KEY_COOKIE_WALLET_TOKEN + this.getCacheAppId())
  },
  removeCacheWalletToken: function () {
    Vue.$cookies.remove(KEY_COOKIE_WALLET_TOKEN + this.getCacheAppId())
  },

  setLoginData(data) {
    Vue.$cookies.set(
      KEY_COOKIE_LOGIN + this.getCacheAppId(),
      data,
      null,
      null,
      null,
      true,
      'Strict',
    )
  },
  getLoginData() {
    return Vue.$cookies.get(KEY_COOKIE_LOGIN + this.getCacheAppId())
  },
  removeLoginData() {
    Vue.$cookies.remove(KEY_COOKIE_LOGIN + this.getCacheAppId())
  },
  /**
   * Set cache user.
   * @param {object} objUser
   */
  setCacheUser: function (objUser) {
    if (this.getCacheAppId() != null) {
      this.removeCacheUser()
      let data = {
        userId: objUser.userId,
        appId: objUser.appId,
        locale: objUser.locale,
        userLevel: objUser.userLevel,
        userLevelDetail: objUser.userLevelDetail,
        sponsorId: objUser.sponsorId,
        uuid: objUser.uuid,
        joinDate: objUser.joinDate,
        channel: objUser.channel,
        TermAndCondition: objUser.TermAndCondition,
        DataPrivacy: objUser.DataPrivacy,
        MarketingOption: objUser.MarketingOption,
        ConsentAge: objUser.ConsentAge,
        EmailMarketing: objUser.EmailMarketing,
        SMSMarketing: objUser.SMSMarketing,
        NotificationMarketing: objUser.NotificationMarketing,
        LineMarketing: objUser.LineMarketing,
        updated_points: objUser.updated_points,

        //***Not used***
        // isFbUser: objUser.isFbUser,
        // userFlags: objUser.userFlags,
        // canRedeem: objUser.canRedeem,
        // detail: objUser.detail,
        // usercode: objUser.usercode,
        // cart_count: objUser.cart_count,
        // platform: objUser.platform,
        // topics: objUser.topics,
        // AnalyticsBuzzebeesCookies: objUser.AnalyticsBuzzebeesCookies,
        // AnalyticsFirebaseCookies: objUser.AnalyticsFirebaseCookies,
        // AnalyticsGoogleCookies: objUser.AnalyticsGoogleCookies,
        // AnalyticsMetaCookies: objUser.AnalyticsMetaCookies,
        // AnalyticsOtherCookies: objUser.AnalyticsOtherCookies,
        // FunctionalCookies: objUser.FunctionalCookies,
        // MarketingCookies: objUser.MarketingCookies,
        // NecessaryCookies: objUser.NecessaryCookies,
        // authenticated: objUser.authenticated,
        // sponsor_pages: objUser.sponsor_pages,
      }
      Vue.$cookies.set(
        KEY_COOKIE_USER + this.getCacheAppId(),
        JSON.stringify(data),
        null,
        null,
        null,
        true,
        'Strict',
      )
    }
  },
  /**
   * Set cache user.
   * @param {object} objUser
   */
  setCacheFacebookUser: function (objUser) {
    if (this.getCacheAppId() != null) {
      this.removeCacheFacebookUser()
      let data = {
        name: objUser.name,
        first_name: objUser.first_name,
        last_name: objUser.last_name,
        birthday: objUser.birthday,
        email: objUser.email,
        gender: objUser.gender,
        picture: objUser.picture,
      }
      Vue.$cookies.set(
        KEY_COOKIE_FACEBOOK_USER + this.getCacheAppId(),
        JSON.stringify(data),
        null,
        null,
        null,
        true,
        'Strict',
      )
    }
  },

  /**
   * Get point.
   * @return {number} User point.
   */
  getCachePoint: function () {
    if (this.isLogin()) {
      let objUser = this.getCacheUser()
      if (
        objUser.updated_points != null &&
        objUser.updated_points.points != null
      ) {
        return objUser.updated_points.points
      }
    }

    return 0
  },

  /**
   * Remove cache user.
   */
  removeCacheUser: function () {
    Vue.$cookies.remove(KEY_COOKIE_USER + this.getCacheAppId())
  },
  /**
   * Remove cache face user.
   */
  removeCacheFacebookUser: function () {
    Vue.$cookies.remove(KEY_COOKIE_FACEBOOK_USER + this.getCacheAppId())
  },

  /**
   * Set user login.
   * @param {object} objUser
   */
  setLogin: function (objUser) {
    this.setCacheUser(objUser)
    this.setCacheToken(objUser.token)
    this.setCacheWalletToken(objUser.ewallet_token)
    let localeCode = objUser.locale
    Locale.setLocale(localeCode)
  },

  /**
   * Set user logout.
   * @return {promises} Logout response.
   */
  setLogout: function () {
    this.removeCacheUser()
    this.removeCacheToken()
    this.removeCacheWalletToken()
    this.removeCacheAllProfile()
    return this.apiLogout()
  },

  /**
   * Update point.
   * @param {object} objUpdatePoints
   */
  updatePoint: function (objUpdatePoints) {
    let objUser = this.getCacheUser()
    let objProfile = this.getCacheProfile()
    objUser.updated_points = objUpdatePoints
    objProfile.updated_points = objUpdatePoints
    this.setCacheUser(objUser)
    this.setCacheToken(objUser.token)
    this.setCacheWalletToken(objUser.ewallet_token)
    this.setCacheProfile(objProfile)
  },

  /**
   * Check login wait for check token status.
   * @return Promise
   */
  loginStatus: function () {
    return new Promise(resolve => {
      if (Vue.initFinished) {
        let strToken = this.getToken()
        let rs = !Util.isEmptyStr(strToken)
        resolve(rs)
      } else {
        let itv = setInterval(() => {
          if (Vue.initFinished) {
            let strToken = this.getToken()
            let rs = !Util.isEmptyStr(strToken)
            clearInterval(itv)
            resolve(rs)
          }
        }, 200)
      }
    })
  },
  checkLoginAction() {
    this.loginStatus().then(status => {
      if (!status) this.lineLogin()
    })
  },
  /**
   * Check login.
   * @return {boolean} Login status.
   */
  isLogin: function () {
    let strToken = this.getToken()
    return !Util.isEmptyStr(strToken)
  },

  /**
   * Get user point.
   * @returns {promises} Update point object.
   */
  apiGetPoint: function () {
    return new Promise((resolve, reject) => {
      let strToken = this.getToken()
      BzbsProfile.getPoint(strToken)
        .then(response => {
          this.updatePoint(response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  /**
   * Bzbs login.
   * @param {string} strUsername
   * @param {string} strPassword
   * @return {object} Return user and profile.
   */
  apiBzbsLogin: function (strUsername, strPassword) {
    return new Promise((resolve, reject) => {
      BzbsAuth.apiLogin(strUsername, strPassword, null, null, null, false)
        .then(response => {
          //Set User to cache.
          this.setLogin(response.data)
          //Get Profile to cache.
          this.apiGetProfile()
            .then(objProfile => {
              //Return User Data from api.
              let objResult = {
                user: response.data,
                profile: objProfile,
              }
              resolve(objResult)
            })
            .catch(error => {
              reject(error)
            })
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  apiBzbsFacebookLogin: function (strUsername, strPassword) {
    return new Promise((resolve, reject) => {
      BzbsAuth.apiBzbsFacebookLogin(
        strUsername,
        strPassword,
        null,
        null,
        null,
        false,
      )
        .then(response => {
          //Set User to cache.
          this.setLogin(response.data)
          //Get Profile to cache.
          this.apiGetProfile()
            .then(objProfile => {
              //Return User Data from api.
              let objResult = {
                user: response.data,
                profile: objProfile,
              }
              resolve(objResult)
            })
            .catch(error => {
              reject(error)
            })
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  apiDeviceLogin: function () {},

  apiFBLogin: function () {},

  /**
   * Logout.
   */
  apiLogout: function () {
    return new Promise((resolve, reject) => {
      let strToken = this.getToken()
      if (!strToken) {
        resolve(null)
      } else {
        BzbsAuth.apiLogout(strToken, null, null)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      }
    })
  },
  //#endregion user

  //#region profile
  /**
   * Get cache profile.
   * @return {object|null} Profile.
   */
  getCacheProfile: function () {
    return Vue.$cookies.get(KEY_COOKIE_PROFILE)
  },

  /**
   * Set cache profile.
   * @param {object|null} objProfile
   */
  setCacheProfile: function (objProfile) {
    this.removeCacheProfile()
    Vue.$cookies.set(
      KEY_COOKIE_PROFILE,
      JSON.stringify(objProfile),
      null,
      null,
      null,
      true,
      'Strict',
    )
  },

  /**
   * Remove cache profile.
   */
  removeCacheProfile: function () {
    Vue.$cookies.remove(KEY_COOKIE_PROFILE)
  },

  /**
   * Get cache profile address.
   * @return {object|null}
   */
  getCacheProfileAddress: function () {
    return Vue.$cookies.get(KEY_COOKIE_PROFILE_ADDRESS)
  },

  /**
   * Set cache profile address.
   * @param {object|null} objProfileAddress
   */
  setCacheProfileAddress: function (objProfileAddress) {
    this.removeCacheProfileAddress()
    Vue.$cookies.set(
      KEY_COOKIE_PROFILE_ADDRESS,
      JSON.stringify(objProfileAddress),
      null,
      null,
      null,
      true,
      'Strict',
    )
  },

  /**
   * Remove cache profile address.
   */
  removeCacheProfileAddress: function () {
    Vue.$cookies.remove(KEY_COOKIE_PROFILE_ADDRESS)
  },
  removeCacheRegisterStore: function () {
    Vue.$cookies.remove(KEY_COOKIE_REGISTERSTORE + this.getCacheAppId())
  },

  /**
   * Get cache profile shipping address.
   * @return {object|null} Profile shipping address
   */
  getCacheProfileShippingAddres: function () {
    return Vue.$cookies.get(KEY_COOKIE_PROFILE_SHIPPING_ADDRESS)
  },

  /**
   * Set cache profile shipping address.
   * @param {object|null} objProfileShippingAddress
   */
  setCacheProfileShippingAddres: function (objProfileShippingAddress) {
    this.removeCacheProfileShippingAddres()
    Vue.$cookies.set(
      KEY_COOKIE_PROFILE_SHIPPING_ADDRESS,
      JSON.stringify(objProfileShippingAddress),
      null,
      null,
      null,
      true,
      'Strict',
    )
  },
  /**
   * Remove cache profile shipping address.
   */
  removeCacheProfileShippingAddres: function () {
    Vue.$cookies.remove(KEY_COOKIE_PROFILE_SHIPPING_ADDRESS)
  },

  /**
   * Set cache for profile, profile address, profile shipping address.
   * @param {object|null} objProfile
   * @param {object|null} objProfileAddress
   * @param {object|null} objProfileShippingAddress
   */
  setCacheAllProfile: function (
    objProfile,
    objProfileAddress,
    objProfileShippingAddress,
  ) {
    console.log(
      'Profile : ',
      objProfile,
      objProfileAddress,
      objProfileShippingAddress,
    )
    //this.removeCacheAllProfile()
    //this.setCacheProfile(objProfile)
    // this.setCacheProfileAddress(objProfileAddress)
    // this.setCacheProfileShippingAddres(objProfileShippingAddress)
  },

  /**
   * Remove all profile cache.
   */
  removeCacheAllProfile: function (resolve) {
    Promise.all([
      this.removeCacheProfile(),
      this.removeCacheProfileAddress(),
      this.removeCacheProfileShippingAddres(),
      this.removeCacheRegisterStore(),
    ]).then(resolve)
  },

  /**
   * Get profile.
   * @return {object|null} Profile.
   */
  apiGetProfile: function () {
    return new Promise((resolve, reject) => {
      let strToken = this.getToken()
      if (!strToken) {
        resolve(null)
      } else {
        BzbsProfile.getProfile(strToken)
          .then(response => {
            let objProfile = new ProfileModel(response.data)
            let objProfileAddress = new ProfileAddressModel(response.data)
            let objProfileShippingAddress = new ProfileShippingAddressModel(
              response.data,
            )
            this.setCacheAllProfile(
              objProfile,
              objProfileAddress,
              objProfileShippingAddress,
            )
            resolve(objProfile)
          })
          .catch(error => {
            if (error.response.data.error.code == 412) {
              this.removeCacheUser()
              this.removeCacheToken()
              this.removeCacheWalletToken()
              this.removeCacheAllProfile()
              location.reload()
              console.log('error token')
            }
            reject(error)
          })
      }
    })
  },

  /**
   * Update user profile.
   * @param {object} objProfile
   * @param {object} objProfileAddress
   * @param {string} strExtendJson
   */
  apiUpdateProfile: function (objProfile, objProfileAddress, strExtendJson) {
    return new Promise((resolve, reject) => {
      let strToken = this.getToken()

      if (!strToken) {
        resolve(null)
      } else {
        BzbsProfile.updateProfile(
          strToken,
          objProfile,
          objProfileAddress,
          strExtendJson,
        )
          .then(response => {
            //Update cache profile.
            let objNewProfile = new ProfileModel(response.data)
            let objProfileAddress = new ProfileAddressModel(response.data)
            let objProfileShippingAddress = new ProfileShippingAddressModel(
              response.data,
            )
            this.setCacheAllProfile(
              objProfile,
              objProfileAddress,
              objProfileShippingAddress,
            )
            //Update cache user.
            let objUser = this.getCacheUser()
            objUser.token = response.data.Token
            objUser.updated_points = objNewProfile.updated_points

            let objResult = {
              objUser: objUser,
              objProfile: objProfile,
            }
            resolve(objResult)
          })
          .catch(error => {
            reject(error)
          })
      }
    })
  },

  /**
   * Update user locale.
   * @param {number} localeCode
   */
  apiUpdateProfileLocale: function (localeCode) {
    let objProfile = this.getCacheProfile()
    if (objProfile) objProfile.locale = localeCode

    let objProfileAddress = this.getCacheProfileAddress()

    return this.apiUpdateProfile(objProfile, objProfileAddress)
  },
  //#endregion profile

  //#region general function
  /**
   * Get cache json by key.
   * @param {string} strCookieKey
   * @return {object|null} Profile extend json.
   */
  getCacheCustom: function (strCookieKey) {
    try {
      return JSON.parse(Vue.$cookies.get(strCookieKey))
    } catch (e) {
      return Vue.$cookies.get(strCookieKey)
    }
  },
  getCache: function (strCookieKey) {
    return Vue.$cookies.get(strCookieKey)
  },

  /**
   * Set cache json by key.
   * @param {string} strCookieKey
   * @param {object|null} objData
   */
  setCacheCustom: function (strCookieKey, objData) {
    this.removeCacheCustom(strCookieKey)
    Vue.$cookies.set(
      strCookieKey,
      JSON.stringify(objData),
      null,
      null,
      null,
      true,
      'Strict',
    )
  },

  /**
   * Remove cache extend json.
   * @param {string} strCookieKey
   */
  removeCacheCustom: function (strCookieKey) {
    Vue.$cookies.remove(strCookieKey)
  },

  getCacheCustomByAppId: function (strCookieKey) {
    try {
      return JSON.parse(
        Vue.$cookies.get(KEY_COOKIE_USER + this.getCacheAppId())[strCookieKey],
      )
    } catch (e) {
      return Vue.$cookies.get(KEY_COOKIE_USER + this.getCacheAppId())[
        strCookieKey
      ]
    }
  },

  setCacheCustomByLine: function (objData) {
    let User = Vue.$cookies.get(KEY_COOKIE_USER + this.getCacheAppId())
    if (User == null) {
      User = {}
    }
    //Vue.$cookies.remove(KEY_COOKIE_USER + this.getCacheAppId())
    let obj = {
      ...User,
    }
    obj['userId'] = objData.userId ? objData.userId : User.userId
    obj['appId'] = objData.appId
    obj['locale'] = objData.locale
    obj['userLevel'] = objData.userLevel
    obj['userLevelDetail'] = objData.userLevelDetail
    obj['sponsorId'] = objData.sponsorId
    obj['uuid'] = objData.uuid
    obj['joinDate'] = objData.joinDate
    obj['channel'] = objData.channel
    obj['TermAndCondition'] = objData.TermAndCondition
    obj['DataPrivacy'] = objData.DataPrivacy
    obj['MarketingOption'] = objData.MarketingOption
    obj['ConsentAge'] = objData.ConsentAge
    obj['EmailMarketing'] = objData.EmailMarketing
    obj['SMSMarketing'] = objData.SMSMarketing
    obj['NotificationMarketing'] = objData.NotificationMarketing
    obj['LineMarketing'] = objData.LineMarketing
    obj['updated_points'] = objData.updated_points

    console.log('set Cache By Line : ', obj)
    Vue.$cookies.set(
      KEY_COOKIE_USER + this.getCacheAppId(),
      JSON.stringify(obj),
      null,
      null,
      null,
      true,
      'Strict',
    )
  },

  setCacheCustomByAppId: function (strCookieKey, objData) {
    let User = Vue.$cookies.get(KEY_COOKIE_USER + this.getCacheAppId())
    if (User == null) {
      User = {}
    }
    if (this.getCacheAppId() != null) {
      Vue.$cookies.remove(KEY_COOKIE_USER + this.getCacheAppId())
      User[strCookieKey] = objData
      Vue.$cookies.set(
        KEY_COOKIE_USER + this.getCacheAppId(),
        JSON.stringify(User),
        null,
        null,
        null,
        true,
        'Strict',
      )
    }
  },

  removeCacheCustomByAppId: function (strCookieKey) {
    let User = Vue.$cookies.get(KEY_COOKIE_USER + this.getCacheAppId())
    if (User == null) {
      User = {}
    }
    if (this.getCacheAppId() != null) {
      delete User[strCookieKey]
      Vue.$cookies.set(
        KEY_COOKIE_USER + this.getCacheAppId(),
        JSON.stringify(User),
        null,
        null,
        null,
        true,
        'Strict',
      )
    }
  },

  getCacheEcomByAppId: function () {
    try {
      return JSON.parse(
        Vue.$cookies.get(KEY_COOKIE_ECOMURL + this.getCacheAppId()),
      )
    } catch (e) {
      return Vue.$cookies.get(KEY_COOKIE_ECOMURL + this.getCacheAppId())
    }
  },
  setCacheEcomByAppId: function (obj) {
    this.removeCacheEcomByAppId()
    Vue.$cookies.set(
      KEY_COOKIE_ECOMURL + this.getCacheAppId(),
      JSON.stringify(obj),
      null,
      null,
      null,
      true,
      'Strict',
    )
  },
  removeCacheEcomByAppId: function () {
    Vue.$cookies.remove(KEY_COOKIE_ECOMURL + this.getCacheAppId())
  },

  // TimeStampMarKetingConsent
  setTimeStampMarKetingConsent: function () {
    this.removeTimeStampMarKetingConsent()
    Vue.$cookies.set(
      KEY_COOKIE_Marketing_Consent + this.getCacheAppId(),
      moment().unix(),
      '3m',
      null,
      null,
      true,
      'Strict',
    )
  },
  getTimeStampMarKetingConsent: function () {
    return Vue.$cookies.get(KEY_COOKIE_Marketing_Consent + this.getCacheAppId())
  },
  removeTimeStampMarKetingConsent: function () {
    Vue.$cookies.remove(KEY_COOKIE_Marketing_Consent + this.getCacheAppId())
  },
  gotoScan(external = true, page) {
    if (!external) {
      window.location =
        'https://liff.line.me/' +
        this.getCacheCustomByAppId('liffId') +
        '?target_page=' +
        page
    } else {
      liff
        .init({
          liffId: this.getCacheCustomByAppId('liffId'),
        })
        .then(() => {
          liff.openWindow({
            url:
              'https://liff.line.me/' +
              this.getCacheCustomByAppId('liffId') +
              '?target_page=' +
              page,
            external: external,
          })
        })
        .catch(error => {
          console.log(`liff error ${error.message}`)
        })
    }
  },

  liffgetOS: function () {
    return liff.getOS()
  },

  lineLogin: function () {
    const liffLogin = () => {
      liff.login({ redirectUri: window.location.href })
    }

    return liff
      .init({
        liffId: this.getCacheCustomByAppId('liffId'),
      })
      .then(() => {
        if (!liff.isLoggedIn()) {
          liffLogin()
          return false
        }
        return liff.getProfile()
      })
      .catch(error => {
        console.log(`liff error ${error.message}`)
        return (window.location = window.location.href)
      })
  },
  actionLineDirectLogin(params, enable) {
    return BzbsAuth.apilinedirectlogin(params, enable)
      .then(res => {
        return res
      })
      .catch(err => {
        return err
      })
  },
  actionLineInfo() {
    let params = {
      appId: this.getCacheAppId(),
    }
    return BzbsAuth.actionGetLineInfo(params)
      .then(res => {
        return res
      })
      .catch(err => {
        return err
      })
  },
  actioncrmpluscustomer(params, token) {
    return BzbsAuth.apicrmpluscustomer(params, token)
      .then(res => {
        return res
      })
      .catch(err => {
        console.log('apiLoginLine err', err)
        return err
      })
  },
  actionGetConsent(params, token) {
    return BzbsAuth.actionGetConsent(params, token)
      .then(res => {
        return res
      })
      .catch(err => {
        console.log('actionGetConsent err', err)
        return err
      })
  },
  lifflogout: function () {
    if (liff.isLoggedIn()) {
      this.setLogout()
      liff.logout()
      window.location.reload()
    }
  },

  //#region cookie consent function
  getCacheCookieConsent: function () {
    return localStorage.getItem(KEY_COOKIE_CONSENT)
  },
  setCacheCookieConsent: function (obj) {
    this.removeCacheCookieConsent()
    localStorage.setItem(KEY_COOKIE_CONSENT, JSON.stringify(obj))
  },
  removeCacheCookieConsent: function () {
    localStorage.removeItem(KEY_COOKIE_CONSENT)
  },
  //#endregion cookie consent function


  bzbsAnalyticTracking: function (Page, Category, Action, Name) {
    console.log(Page, Category, Action, Name)
    // var script = document.createElement('script')
    // script.src = Vue.bzbsConfig.bzbsAnalyticId
    // script.nonce = 'JsGpw3rZDMuUtUYq'
    // document.head.appendChild(script)
    var userId =
      this.getCacheUser() && this.getCacheUser.userId
        ? this.getCacheUser().userId
        : ''
    var _paq = (window._paq = window._paq || [])
    if (Vue.bzbsConfig.env !== 'dev') {
      _paq.push(['setDocumentTitle', Page])
      _paq.push(['trackPageView'])
      _paq.push(['setUserId', userId])
      _paq.push(['setCustomVariable', 1, 'Category', Page, 'page'])
      _paq.push(['trackEvent', Category, Action, Name])
      _paq.push(['enableLinkTracking'])
      ;(function () {
        var u = Vue.bzbsConfig.bzbsAnalyticUrl
        _paq.push(['setTrackerUrl', u + 'matomo.php'])
        _paq.push(['setSiteId', Vue.bzbsConfig.bzbsAnalyticId]) 
        var d = document,
          g = d.createElement('script'),
          s = d.getElementsByTagName('script')[0]
        g.type = 'text/javascript'
        g.async = true
        g.src = u + 'matomo.js'
        // g.setAttribute('nonce', 'nonce-JsGpw3rZDMuUtUYq')
        s.parentNode.insertBefore(g, s)
        console.log('====bzbsAnalyticTracking====')
      })()
    }
  },
}
